export default __webpack_public_path__ + "static/media/list_update_friends_page.d3181718.png";